import axiosInstance from "../../../Utils/axios";

//obtaining the paginated data
export const getShortcutItem = () => axiosInstance.get(`api/v1/item/item?offset=0&limit=0&ordering=-id`);

//obtaining the next page data from paginated data
export const getNext = (next) => axiosInstance.get(next);
//searching function
export const handleSearch = (search) => axiosInstance.get(`api/v1/item/item?offset=0&limit=0&search=${search}`);
